<!--modal-dialog-container-800-->
<div class="modal-dialog-header">
    <div class="container">
        <img src='assets/ico_cotizador/ico_log_h.png' style=" max-width: 70%;  height:74.2px;">
    </div>
</div>
<div class="modal-dialog-body">
    <div class="container-text-alert">
        <div class="row">
            <div class="col-md-12" style="text-align: center; background-color:white">
                <span class="modal-dialog-title fuente">{{title}}</span>
                <br>

                <span id="lblMensaje" class="modal-dialog-message fuente" style="text-align: center;">{{ message }}</span>

            </div>
        </div>
    </div>
</div>

<div class="modal-dialog-footer" style="padding-top: 10px;">
    <div *ngIf="confirm" class="modal-dialog-button modal-dialog-button-cancel"
        style="background-color: var(--main-gray-light-color);" (click)="close()">Cancelar</div>
    <div class="modal-dialog-button" style="background-color: var(--main-app-color);" (click)="accept() ">Aceptar
    </div>
</div>





<!--<div class="modal-dialog-container">
    <div class="modal-dialog-header">
        <img src="/src/assets/ico/ico_log_h.png" style=" width: 70%;">
    </div>
    <div class="modal-dialog-body" style="margin-right: 10%; margin-left: 10%;">
        <span class="modal-dialog-title fuente">{{title}}</span>
        <br>
        <span class="modal-dialog-message fuente" style="text-align: center;">{{ message }}</span>
    </div>
    <div class="modal-dialog-footer">
        <div *ngIf="confirm" class="modal-dialog-button modal-dialog-button-cancel" style="background-color: var(--main-gray-light-color);" (click)="close()">Cancelar</div>
        <div class="modal-dialog-button" style="background-color: var(--main-app-color);" (click)="accept() ">Aceptar</div>
    </div>
</div>
-->